import { NgModule } from '@angular/core';
import { FLXNoResultsComponent } from './no-results.component';

@NgModule({
	imports: [],
	declarations: [FLXNoResultsComponent],
	exports: [FLXNoResultsComponent]
})
export class FLXNoResultsModule {}
